function validateUpperChar(pass) {
  return pass.toLowerCase() != pass;
}

function validateLength(pass) {
  return pass.length > 8;
}

function validateLowerChar(pass) {
  return pass.toUpperCase() != pass;
}

function validateNumber(pass) {
  return pass.match(/\d+/g);
}

function validateSpecialChar(pass) {
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return specialChars.test(pass);
}

export default () => ({
  lengthValid: false,
  lowercaseValid: false,
  uppercaseValid: false,
  numberValid: false,
  specialCharacterValid: false,
  passwordInputType: "password",
  onPasswordChange(e) {
    this.validatePassword(e.target.value);
  },
  togglePassword(e) {
    this.passwordInputType =
      this.passwordInputType === "password" ? "text" : "password";
  },
  validatePassword(password) {
    this.lengthValid = validateLength(password);
    this.lowercaseValid = validateLowerChar(password);
    this.uppercaseValid = validateUpperChar(password);
    this.numberValid = validateNumber(password);
    this.specialCharacterValid = validateSpecialChar(password);
  },
});
